import script from "./ScrapPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrapPage.vue?vue&type=script&setup=true&lang=js"

import "./ScrapPage.vue?vue&type=style&index=0&id=83c7ebe4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/sakai-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83c7ebe4"]])

export default __exports__